module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/reorder-9b872e82c9492a437439327fcdfc654b.svg";